import { Card, Flex, Typography } from "antd";
import Chart from "react-apexcharts";
import React from "react";

export default function ARAging() {
  return (
    <Card style={{ minWidth: 350, height: 350 }}>
      <Flex vertical gap={12}>
        {/* Reduced from 30 to 12 */}
        <Typography.Title level={4} style={{ marginBottom: 0 }}>
          Ar Aging
        </Typography.Title>
        <ARAgingChart />
      </Flex>
    </Card>
  );
}

function ARAgingChart() {
  const options = {
    chart: {
      type: "bar",
      height: 200, // Reduced from 220
      toolbar: { show: false },
      zoom: { enabled: false },
      parentHeightOffset: 0, // Removes bottom white gap
      animations: {
        enabled: true,
        easing: "easeinout",
        speed: 800,
      },
    },
    plotOptions: {
      bar: {
        borderRadius: 6,
        columnWidth: "17%",
        dataLabels: {
          position: "top",
        },
      },
    },
    stroke: {
      show: true,
      width: 1,
      colors: ["transparent"],
    },
    dataLabels: { enabled: false },
    xaxis: {
      categories: ["0-29 Days", "30-59 Days", "60-89 Days", "90+ Days"],
      labels: {
        style: {
          fontSize: "12px",
          fontFamily: "Helvetica, Arial, sans-serif",
          colors: "#979797",
        },
      },
      axisBorder: { show: false },
      axisTicks: { show: false },
    },
    yaxis: {
      min: 0,
      max: 100,
      tickAmount: 5,
      labels: {
        formatter: (val) => `${val}%`,
        style: {
          fontSize: "12px",
          colors: "#979797",
        },
      },
    },
    grid: {
      show: false,
      // borderColor: "#f0f0f0",
      // xaxis: { lines: { show: false } },
      // yaxis: { lines: { show: true } },
    },
    legend: { show: false },
    colors: ["#722ed1"],
    tooltip: {
      y: {
        formatter: (val) => `${val}%`,
      },
    },
    states: {
      hover: {
        filter: { type: "none" },
      },
    },
  };

  const series = [
    {
      name: "AR Aging",
      data: [90, 60, 30, 70],
    },
  ];

  return <Chart options={options} series={series} type="bar" height={290} />;
}
